import { useEffect, useState } from "react";

/** Die Hausgrenze: bis hier ist es ein Telefon, darueber Tablet oder Schreibtisch. */
const TELEFON = "(max-width: 760px)";

/**
 * True, solange das Fenster Telefonbreite hat.
 *
 * Fuer Faelle, in denen sich Bedienung und nicht nur Layout unterscheidet und
 * eine Media-Query darum nicht reicht — etwa das Zeitrad, das am Telefon die
 * Tastatur erspart, am Schreibtisch aber langsamer ist als ein Zahlenfeld.
 * Wo es nur um Aussehen geht, gehoert die Regel weiter in die CSS-Datei.
 *
 * Reagiert auf Drehung und Groessenaenderung. Ausserhalb des Browsers (SSR,
 * Testlauf ohne DOM) meldet er false, also die Schreibtisch-Variante.
 */
export function useIstTelefon(): boolean {
  const [ist, setIst] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(TELEFON).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(TELEFON);
    const zeige = (e: MediaQueryListEvent) => setIst(e.matches);
    setIst(mq.matches);
    mq.addEventListener("change", zeige);
    return () => mq.removeEventListener("change", zeige);
  }, []);

  return ist;
}
